export default __webpack_public_path__ + "static/media/heroku.193dbd4c.svg";